import { Breadcrumb, Button } from "antd";
import { useNavigate } from "react-router";
import "./auth.css";
import CallUsComponet from "../../components/callUs";
import BANK_LOGO from "client/assets/LOGO/BANK_LOGO.png";
import { useTranslation } from "react-i18next";

export default function CallUs() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <>
      <div align="center" style={{ marginTop: "70px" }}>
        <img src={BANK_LOGO} height={50} alt="Bank Logo" />
      </div>
      <div className="mt-5">
        <CallUsComponet />
      </div>
      <div className="text-center back-footer">
        <Button type="link" onClick={() => navigate("/landing")}>
          {t("buttons.back_btn", {
            defaultValue: "Back",
          })}
        </Button>
      </div>
    </>
  );
}
